enum TCarbonUnit {
  tCO2e = "tCO2e",
  kgCO2e = "kgCO2e",
  gCO2e = "gCO2e",
}

export { TCarbonUnit };
